export const wafferShowConditions = (status) => {
    const bannerOptions = [
        'KO_DTI',
        'DENEGADO_ANTES_PREAPROB',
        'DENEGADO_TRAS_PREAPROB',
        'DENEGADO_TRAS_APROB',
        'DENEGADO',
        'CANCELADO',
        'NO_REGISTRO',
        'NO_RECORD',
        '',
    ]

    return bannerOptions.includes(status)
}